import { ISaveUserRequest } from "common/interfaces/apiRequest/ISaveUserRequest";
import { IUpdateUserRequest } from "common/interfaces/apiRequest/IUpdateUserRequest";
import { IADUser } from "common/interfaces/IADUser";
import { IUser } from "common/interfaces/IUser";
import { IUserAudit } from "common/interfaces/IUserAudit";
import { UserApi } from "core/api/UserApi";
import { action, makeAutoObservable, observable, runInAction } from "mobx";

export class UserStore {
    @observable public users: IUser[] = [];
    @observable public selectedUser: IUser | undefined = undefined;
    @observable public currentUser: IUser | undefined = undefined;
    @observable public isUserOperation: boolean = false;
    @observable public userOperationMessage: string = "";
    @observable public messageVariant: any = "";
    @observable public adusers: IADUser[] = [];
    @observable public newUser: IUser = {};
    @observable public auditEntries: IUserAudit[] = [];

    constructor() {
        makeAutoObservable(this);
        //this.getAllUsers();
    }

    @action public clearUserOperationFlags() {
        runInAction(() => {
            this.isUserOperation = false;
            this.userOperationMessage = "";
            this.messageVariant = "";
        });
    }

    @action
    public async getAdUsers(searchPattern: string): Promise<IADUser[]> {
        var response = await UserApi.getAdUsers(searchPattern);

        const users: any[] = response.value;
        let count = 1;
        const adusers: IADUser[] = users.map<IADUser>((x) => ({ firstName: x.givenName, surname: x.surname, mail: x.mail, rowId: count++ }));

        this.adusers = adusers;
        return adusers;
    }

    @action
    public async setCurrentUser(): Promise<any> {
        return UserApi.getCurrentUser().then((response) => {
            runInAction(() => {
                this.currentUser = response.user;
            });
        });
    }

    @action
    public async getCurrentUser(): Promise<any> {
        return UserApi.getCurrentUser();
    }
        
    public  isCurrentUserApplicationAdmin() : boolean {
        return this.currentUser?.userType == "Application Admin" ;
    }


    @action
    public async getAllUsers(): Promise<any> {
        return UserApi.getUsers().then((response) => {
            runInAction(() => {
                this.users = response.users;
            });
        });
    }

    @action
    public async saveUser(saveUserRequest: ISaveUserRequest): Promise<any> {
        var response = await UserApi.saveUser(saveUserRequest);
        runInAction(() => {
            if (response.success == true) {
                this.isUserOperation = true;
                this.userOperationMessage = `User ${saveUserRequest.name} created successfully`;
                this.messageVariant = "success";
            } else {
                this.isUserOperation = true;
                this.userOperationMessage = `User ${saveUserRequest.name} could not be created`;
                this.messageVariant = "error";
            }
        });
        return response;
    }

    @action
    public async updateUser(updateUserRequest: IUpdateUserRequest): Promise<any> {
        var response = await UserApi.updateUser(updateUserRequest);
        runInAction(() => {
            if (response.success == true) {
                this.isUserOperation = true;
                this.userOperationMessage = `User ${updateUserRequest.name} updated successfully`;
                this.messageVariant = "success";
            } else {
                this.isUserOperation = true;
                this.userOperationMessage = `User ${updateUserRequest.name} could not be updated`;
                this.messageVariant = "error";
            }
        });
        return response;
    }

    @action
    public async getUserById(userId: number) {
        var response = await UserApi.getUserById(userId);
        runInAction(() => {
            this.selectedUser = response.user;
        });
    }

    @action
    public async getUserByIdPromise(userId: number) {
        return UserApi.getUserById(userId);       
    }

    @action public async resetSelectedUser() {
        this.selectedUser = undefined;
    }

    @action
    public async getUserAudit(userId: number): Promise<IUserAudit[]> {
        var response = await UserApi.getUserAuditById(userId);
        runInAction(() => {
            this.auditEntries = response.auditEntries;
        });
        return response.auditEntries;
    }
}
